import React, { Component } from 'react';
import { Form, Input, Spin } from 'antd';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import isEmpty from 'loadsh/isEmpty';
import { GoogleLogin } from '@react-oauth/google';

import { authActions } from 'redux/actions';
import { device, formValidateMessages } from 'utils';
import ExternalLinkOnLogin from 'components/ExternalLink/ExternalLinkOnLogin';

const FormItem = Form.Item;

const RegisterFormWrapper = styled.div`
  width: 385px;
  background: #ffffff;
 
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
    @media
    ${device.allMobile} {
    width: 100%;
    min-width: 1px;
    max-width: 100%;
    min-height: auto;
    box-shadow: none;
    border-radius: 0;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const LogoWrap = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;

  img {
    width: 32px;
    height: auto;
    object-fit: contain;
  }
`;

const TitleGroup = styled.div`
  width: 100%;
`;

const Title = styled.h2`
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: #181d27;
`;

const Subtitle = styled.p`
  margin: 4px 0 0;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #535862;
`;

const Spacer = styled.div`
  height: 20px;
`;

const Body = styled.div`

  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StyledForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 16px;
  }

  .ant-form-item-label {
    padding-bottom: 6px;

    > label {
      font-family: 'Inter', sans-serif;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #414651;
      height: auto;
    }
  }

  .ant-input,
  .ant-input-affix-wrapper {
    height: 44px;
    padding: 10px 14px;
    border: 1px solid #d5d7da;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: #181d27;
  }

  .ant-input::placeholder,
  input::placeholder {
    color: #717680;
  }

  .ant-input-affix-wrapper input {
    height: auto;
    padding: 0;
    box-shadow: none !important;
  }

  .ant-input-affix-wrapper-focused,
  .ant-input:focus,
  .ant-input-focused {
    border-color: #9dbc60;
    box-shadow: 0 0 0 2px rgba(157, 188, 96, 0.12);
  }

  .ant-form-item-has-error .ant-input,
  .ant-form-item-has-error .ant-input-affix-wrapper {
    border-color: #fda29b !important;
    box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05) !important;
  }

  .ant-form-item-explain,
  .ant-form-item-explain-error {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: #d92d20;
    margin-top: 6px;
  }
  input[type='password']{
    border: none;  
  }
  
  input[type='email'],
  input[type='password'],
  input[type='text'] {
    @media ${device.allMobile} {
      font-size: 16px !important;
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: transparent;
    }
  }
`;

const Actions = styled.div`
  padding: 32px 0px 0px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SubmitButton = styled.button`
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 8px;
  background: #9dbc60;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
`;

const GoogleButtonWrap = styled.div`
  width: 100%;

  > div {
    width: 100% !important;
  }

  iframe {
    width: 100% !important;
  }
`;

const FooterText = styled.div`
  margin-top: 16px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #535862;
  text-align: left;

  a {
    color: #3f621a;
    font-weight: 500;
    text-decoration: none;
  }
`;

class SingUpForm extends Component {
  static propTypes = {
    handleCurrentFormState: PropTypes.func,
    loading: PropTypes.bool,
    errors: PropTypes.array,
    register: PropTypes.func.isRequired,
    user: PropTypes.object,
    singUpSuccess: PropTypes.bool,
    handelCloseModal: PropTypes.func,
  };

  state = {
    redirectToProfile: false,
  };

  onFinish = (values) => {
    const { register } = this.props;
    register(values);
  };

  componentDidUpdate(prevProps) {
    const { singUpSuccess, handelCloseModal } = this.props;
    if (singUpSuccess && !prevProps.singUpSuccess) {
      handelCloseModal && handelCloseModal();
    }
  }

  handleSuccess = (response) => {
    const token = response.credential;
    this.props.loginWithGoogle({ token });

    if (this.props.onRegisterSuccess) {
      this.props.onRegisterSuccess();
    } else {
      this.setState({ redirectToProfile: true });
    }
  };

  handleError = () => {
    console.log('Google login failed');
  };

  render() {
    const { handleCurrentFormState, loading, user, singUpSuccess, navigate } =
      this.props;

    const userToken = localStorage.getItem('access-token');
    const client = localStorage.getItem('client');
    const isLoggedIn = !isEmpty(user) && userToken && client;

    return (
      <Spin spinning={loading}>
        {singUpSuccess &&
          (this.props.onRegisterSuccess
            ? this.props.onRegisterSuccess()
            : navigate && <Redirect to={{ pathname: '/welcome' }} />)}

        {isLoggedIn && <ExternalLinkOnLogin href="/" />}

        <RegisterFormWrapper>
          <Header>
            <TitleGroup>
              <Title>Willkommen bei commonsplace!</Title>
              <Subtitle>Bitte registriere dich, um fortzufahren.</Subtitle>
            </TitleGroup>
          </Header>

          <Spacer />

          <Body>
            <StyledForm
              name="sing-up"
              layout="vertical"
              validateMessages={formValidateMessages}
              onFinish={this.onFinish}
            >
              <FormItem
                name="firstName"
                label="Vorname"
                rules={[{ required: true }]}
              >
                <Input placeholder="Dein Vorname" />
              </FormItem>

              <FormItem
                name="lastName"
                label="Nachname"
                rules={[{ required: true }]}
              >
                <Input placeholder="Dein Nachname" />
              </FormItem>

              <FormItem
                name="email"
                label="E-Mail"
                rules={[
                  {
                    required: true,
                    message: 'Bitte gib deine E-Mail-Adresse ein.',
                  },
                ]}
              >
                <Input type="email" placeholder="Deine E-Mail-Adresse" />
              </FormItem>

              <FormItem
                name="password"
                label="Passwort"
                rules={[
                  {
                    required: true,
                    message: 'Bitte gib dein Passwort ein.',
                  },
                ]}
                hasFeedback
              >
                <Input placeholder="Gib ein Passwort ein" type="password" />
              </FormItem>

              <FormItem
                name="passwordConfirmation"
                label="Passwort wiederholen"
                dependencies={['password']}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: 'Bitte bestätige dein Passwort!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }

                      return Promise.reject(
                        new Error('Die Passwörter stimmen nicht überein')
                      );
                    },
                  }),
                ]}
              >
                <Input placeholder="Passwort wiederholen" type="password" />
              </FormItem>

              <Actions>
                <SubmitButton type="submit">Registrieren</SubmitButton>

                <GoogleButtonWrap>
                  <GoogleLogin
                    onSuccess={this.handleSuccess}
                    onError={this.handleError}
                    theme="outline"
                    text="signin_with"
                    shape="rectangular"
                    size="large"
                  />
                </GoogleButtonWrap>
              </Actions>

              <FooterText>
                Bereits registriert?{' '}
                <Link to="#!" onClick={() => handleCurrentFormState('login')}>
                  Jetzt anmelden!
                </Link>
              </FooterText>
            </StyledForm>
          </Body>
        </RegisterFormWrapper>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => {
  const { user, loading, errors, singUpSuccess } = state.authentication;
  return {
    user,
    loading,
    errors,
    singUpSuccess,
  };
};

const mapDispatchToProps = (dispatch) => ({
  register: (user) => dispatch(authActions.register(user)),
  loginWithGoogle: (user) => dispatch(authActions.loginWithGoogle(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SingUpForm);
